// GAVION test mode (58_gavion_test_mode.sql): test leads and the dialer's admin-only « Mode test ».
export const testModeFr = {
  badge: "TEST",
  badge_hint:
    "Compagnie de test : appelée seulement en mode test, jamais comptée dans les statistiques.",
  lead_switch: "Compagnie de test",
  lead_switch_hint:
    "Réservé aux admins. Une compagnie de test n'est appelée qu'en « Mode test » (à toute heure) et n'entre dans aucune statistique.",
  dialer_switch: "Mode test",
  dialer_switch_hint:
    "Admins seulement : n'appelle que les compagnies de test, à toute heure. Démarre une nouvelle session.",
  dialer_switch_busy: "Choisis d'abord un résultat pour l'appel en cours.",
  banner:
    "Mode test — seules les compagnies de test sont appelées, heures d'appel ignorées",
  empty:
    "Aucune compagnie de test à appeler maintenant. Crée-en une, ou ajoute un numéro à une compagnie de test.",
  create: "Créer une compagnie de test",
  default_name: "Compagnie de test",
  created:
    "Compagnie de test créée. Ajoute ton numéro de téléphone et ton courriel.",
  create_failed: "Impossible de créer la compagnie de test.",
  forbidden: "Le mode test est réservé aux admins.",
};
